// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"59fc2814b342fcd08a5c","655":"098658d60c68dbd6a98f"}[chunkId] + ".js";
};